import { render, staticRenderFns } from "./EditPet.vue?vue&type=template&id=08441791&scoped=true&"
import script from "./EditPet.vue?vue&type=script&lang=js&"
export * from "./EditPet.vue?vue&type=script&lang=js&"
import style0 from "./EditPet.vue?vue&type=style&index=0&id=08441791&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08441791",
  null
  
)

export default component.exports